import { render, staticRenderFns } from "./MailsEdit.vue?vue&type=template&id=644dac06"
import script from "./MailsEdit.vue?vue&type=script&lang=ts"
export * from "./MailsEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644dac06')) {
      api.createRecord('644dac06', component.options)
    } else {
      api.reload('644dac06', component.options)
    }
    module.hot.accept("./MailsEdit.vue?vue&type=template&id=644dac06", function () {
      api.rerender('644dac06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/MailsEdit.vue"
export default component.exports